import { Control, Controller, FieldPath, FieldValues } from "react-hook-form";
import { TextInput, View, Text } from "react-native";
import { useCSSVariable } from "uniwind";
import { cn } from "@/shared/lib/utils";

type FormTextareaProps<T extends FieldValues> = {
  control: Control<T>;
  name: FieldPath<T>;
  label: string;
  placeholder?: string;
  numberOfLines?: number;
  minHeight?: number;
  className?: string;
  containerClassName?: string;
};

export function FormTextarea<T extends FieldValues>({
  control,
  name,
  label,
  placeholder,
  numberOfLines = 4,
  minHeight = 80,
  className,
  containerClassName,
}: FormTextareaProps<T>) {
  const [mutedForeground] = useCSSVariable(["--color-muted-foreground"]) as [
    string,
  ];

  return (
    <Controller
      control={control}
      name={name}
      render={({
        field: { onChange, onBlur, value },
        fieldState: { error },
      }) => (
        <View className={cn("mb-4 w-full", className)}>
          <View
            className={cn(
              "bg-card-event border-b px-4 pt-3 pb-2",
              error ? "border-destructive" : "border-white",
              containerClassName
            )}
          >
            <Text className="text-muted-foreground mb-1 text-xs">{label}</Text>
            <TextInput
              className="text-foreground flex-1 text-base leading-tight outline-none"
              onBlur={onBlur}
              onChangeText={onChange}
              value={value}
              placeholder={placeholder}
              placeholderTextColor={mutedForeground}
              multiline
              numberOfLines={numberOfLines}
              autoCapitalize="none"
              style={{ minHeight, textAlignVertical: "top" }}
            />
          </View>
          {error && (
            <Text className="text-destructive mt-1 px-4 text-xs">
              {error.message}
            </Text>
          )}
        </View>
      )}
    />
  );
}
